<div *ngIf="printFile">
  <br/>
  <div class="row">
    <div class="col">
      <h4>{{ 'Filnamn' | translate }}</h4>
      <div><a href="{{printFile.url}}" target="_blank">{{printFile.fileName}}</a></div>
    </div>
    <div class="col">
      <h4>SKU</h4>
      <div>{{printFile.sku}}</div>
    </div>
    <div class="col">
      <h4>{{ 'Storlek' | translate }}</h4>
      <div>{{printFile.posterSize}}</div>
    </div>
  </div>
  <div class="row" *ngIf="url">
    <div class="col">
      <br/>
      <iframe [src]="url"></iframe>
    </div>
  </div>
</div>
